import { saveAs } from 'file-saver'

const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null,
  irEmailRequested: false
}

export const ACTION_TYPES = {
  INCOME_REPORT_REQUEST: 'INCOME_REPORT_REQUEST',
  INCOME_REPORT_SUCCESS: 'INCOME_REPORT_SUCCESS',
  INCOME_REPORT_ERROR: 'INCOME_REPORT_ERROR',
  INCOME_REPORT_REQUEST_EMAIL: 'INCOME_REPORT_REQUEST_EMAIL',
  INCOME_REPORT_REQUEST_EMAIL_SUCCESS: 'INCOME_REPORT_REQUEST_EMAIL_SUCCESS'
}

const getIncomeReportSuccess = (state, { data }) => {
  const blob = new Blob([data], { type: 'application/pdf' })
  saveAs(blob, 'InformeRendimentos.pdf')
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    irEmailRequested: false,
    data
  }

  return newState
}

const postIncomeReportSuccess = state => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    irEmailRequested: true
  }

  return newState
}

export const getIncomeReport = payload => ({
  type: ACTION_TYPES.INCOME_REPORT_REQUEST,
  payload
})

export const postIncomeReport = payload => ({
  type: ACTION_TYPES.INCOME_REPORT_REQUEST_EMAIL,
  payload
})

const incomeReport = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.INCOME_REPORT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.INCOME_REPORT_REQUEST_EMAIL:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.INCOME_REPORT_SUCCESS:
      return getIncomeReportSuccess(state, action.payload)
    case ACTION_TYPES.INCOME_REPORT_REQUEST_EMAIL_SUCCESS:
      return postIncomeReportSuccess(state)
    case ACTION_TYPES.INCOME_REPORT_ERROR:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        error: true,
        data: action.payload
      }
    default:
      return state
  }
}

export default incomeReport
